var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.depth === 0 && !_vm.hasChildren
    ? _c("b-nav-item", { attrs: { href: _vm.href, to: _vm.href } }, [
        _vm._v(_vm._s(_vm.title)),
      ])
    : !_vm.hasChildren
    ? _c("b-dropdown-item", { attrs: { href: _vm.href, to: _vm.href } }, [
        _vm._v(_vm._s(_vm.title)),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }